var Base = require('_js/base'),
  ko = require('knockout'),
  filter = require('lodash/filter'),
  find = require('lodash/find'),
  each = require('lodash/each');

function MultiSelect(params) {
  if (!params.checkedCallback) {
    throw 'Need to provide a callback for when checkboxes are checked';
  }
  var self = this;
  this.emptyListEvent = params.emptyListEvent;
  this.updateListEvent = params.updateListEvent;
  this.removeItemEvent = params.removeItemEvent;
  this.clearFiltersEvent = params.clearFiltersEvent;
  this.options = ko.observableArray(params.options || []);
  this.title = ko.observable(params.title || 'Vis alle');
  this.isActive = ko.observable(false);

  var answers = [];

  if (params.category()) {
    answers = params.category().split(',');
  }

  this.checkedOptions = ko.observableArray(answers);
  this.checkedOptions.subscribe(function(val) {
    params.checkedCallback(this.checkedOptions());
    if (val.length === 0) {
      this.title('Vis alle');
    } else {
      this.title('Endre valg');
    }
    this.updateList();
  }, this);
  if (answers.length > 0) {
    this.title('Endre valg');
  }

  if (this.removeItemEvent) {
    ko.postbox.subscribe(this.removeItemEvent, function(item) {
      var newArr = filter(self.checkedOptions(), function(o) {
        if (item.Key !== parseInt(o, 10)) {
          return true;
        }
        return false;
      });
      self.checkedOptions(newArr);
    });
  }

  if (this.clearFiltersEvent) {
    ko.postbox.subscribe(this.clearFiltersEvent, function() {
      self.clearOptions();
    });
  }

  // Clicks outside the multiselect will close the dropdown.
  ko.postbox.subscribe('maincontent', function(newVal) {
    if (newVal === 'click') {
      self.isActive(false);
    }
  });

  this.updateList();
}

MultiSelect.prototype = new Base();

MultiSelect.prototype.init = function(element) {
  this.$element = $(element);
  // Clicks on the element will not trigger the closing of the multiselect.
  this.$element.on('click', function(e) {
    e.stopPropagation();
  });
};

MultiSelect.prototype.updateList = function() {
  if (this.updateListEvent) {
    ko.postbox.publish(this.updateListEvent, this.findOptions());
  }
};

MultiSelect.prototype.removeParent = function(list, key) {
  return filter(list, function(item) {
    return item.Key !== key;
  });
};

MultiSelect.prototype.hasChildrenSelected = function(list, keys) {
  var result = find(list, function(item) {
    for (var i = 0; i < keys.length; i++) {
      if (parseInt(keys[i], 10) === item.Key) {
        return true;
      }
    }
    return false;
  });
  return result !== undefined;
};

MultiSelect.prototype.findOptions = function() {
  var self = this;
  var checkedOptions = this.checkedOptions();
  var newOptions = [];

  for (var i = 0; i < checkedOptions.length; i++) {
    each(this.options(), function(o) {
      if (o.Key === parseInt(checkedOptions[i])) {
        // Only add this option if it has no children that are selected.
        if (!self.hasChildrenSelected(o.List, checkedOptions)) {
          newOptions.push(o);
          return o;
        }
      } else if (o.List.length > 0) {
        for (var j = 0; j < o.List.length; j++) {
          if (o.List[j].Key === parseInt(checkedOptions[i], 10)) {
            newOptions.push(o.List[j]);
            newOptions = self.removeParent(newOptions, o.Key);
            return o.List[j];
          }
        }
      }
    });
  }

  return newOptions;
};

MultiSelect.prototype.clearOptions = function() {
  this.checkedOptions([]);
  if (this.emptyListEvent) {
    ko.postbox.publish(this.emptyListEvent);
  }
};

MultiSelect.prototype.toggleMultiSelect = function() {
  this.isActive(!this.isActive());
};

module.exports = MultiSelect;
